import React from 'react';

const Services = () => {
  const services = [
    {
      icon: 'fas fa-file-alt',
      title: 'Wnioski Grantowe',
      description: 'Kompleksowe przygotowanie wniosków o dofinansowanie z programów krajowych i unijnych.',
      features: [
        'Analiza możliwości finansowania',
        'Przygotowanie dokumentacji',
        'Budżetowanie projektu',
        'Wsparcie w składaniu wniosku'
      ]
    },
    {
      icon: 'fas fa-chart-line',
      title: 'Biznesplany',
      description: 'Profesjonalne biznesplany dla startupów, firm oraz projektów inwestycyjnych.',
      features: [
        'Analiza rynku i konkurencji',
        'Prognozy finansowe',
        'Strategia rozwoju',
        'Prezentacja dla inwestorów'
      ]
    },
    {
      icon: 'fas fa-handshake',
      title: 'Doradztwo Strategiczne',
      description: 'Kompleksowe konsultacje w zakresie pozyskiwania finansowania i rozwoju organizacji.',
      features: [
        'Audyt organizacyjny',
        'Strategia pozyskiwania funduszy',
        'Optymalizacja procesów',
        'Mentoring kadry zarządzającej'
      ]
    },
    {
      icon: 'fas fa-graduation-cap',
      title: 'Szkolenia i Warsztaty',
      description: 'Specjalistyczne szkolenia z pisania wniosków i zarządzania projektami.',
      features: [
        'Warsztaty grupowe',
        'Szkolenia indywidualne',
        'Materiały szkoleniowe',
        'Certyfikaty uczestnictwa'
      ]
    },
    {
      icon: 'fas fa-search-dollar',
      title: 'Fundraising',
      description: 'Strategiczne pozyskiwanie środków od darczyńców prywatnych i instytucjonalnych.',
      features: [
        'Identyfikacja darczyńców',
        'Kampanie fundraisingowe',
        'Grant writing dla fundacji',
        'Budowanie relacji z fundatorami'
      ]
    }
  ];

  return (
    <section id="services" className="services">
      <div className="container">
        <div className="section-header">
          <div className="section-subtitle">Nasze usługi</div>
          <h2>Kompleksowe Wsparcie w Pozyskiwaniu Finansowania</h2>
          <p>
            Oferujemy pełen zakres usług związanych z pozyskiwaniem środków zewnętrznych 
            i rozwojem organizacyjnym. Nasze doświadczenie gwarantuje profesjonalną obsługę.
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">
                <i className={service.icon}></i>
              </div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex}>
                    <i className="fas fa-check"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
